import {
  Box,
  Button,
  Dialog,
  DialogContent,
  DialogTitle,
  IconButton,
  Typography,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import DownloadOutlinedIcon from "@mui/icons-material/DownloadOutlined";
import PrintIcon from "@mui/icons-material/Print";
import {
  bookingSurname,
  formatHeroDate,
  formatIsoDate,
  formatTapDate,
  formatTime,
  productTypeCode,
  qrImageUrl,
  terminalNumber,
  vehicleLabel,
} from "./tapUtils";
import { printDepartureDockets } from "./printDockets";
import * as docketHelpers from "./tapUtils";

const DocketCard = ({ booking, index, total }) => {
  const code = productTypeCode(booking.productType);
  const typeLabel = code === "SELF" ? "SP" : code;
  const qr = qrImageUrl(booking.referenceNumber || booking._id);
  const returnTerminal = terminalNumber(booking.returnTerminal);

  return (
    <Box
      sx={{
        backgroundColor: "#fff",
        color: "#111",
        border: "1px solid #ddd",
        p: 3,
        mb: 3,
        minHeight: 520,
        fontFamily: "Arial, Helvetica, sans-serif",
      }}
    >
      <Box display="flex" justifyContent="space-between" fontSize="0.75rem" color="#666" mb={2}>
        <span>
          {new Date().toLocaleString("en-GB", {
            year: "numeric",
            month: "2-digit",
            day: "2-digit",
            hour: "2-digit",
            minute: "2-digit",
          })}
        </span>
        <span>Print</span>
        <span>
          {index + 1}/{total}
        </span>
      </Box>
      <Box display="grid" gridTemplateColumns="28% 44% 28%" gap={2} minHeight={400}>
        <Box>
          <Box component="img" src={qr} alt="QR" width={88} height={88} />
          <Box mt={2} lineHeight={1.4}>
            <Typography fontWeight={800} fontSize="1.2rem">
              {bookingSurname(booking.name)}
            </Typography>
            <Typography fontWeight={700}>{booking.referenceNumber}</Typography>
            <Typography>{booking.mobile || "—"}</Typography>
          </Box>
          <Box mt={2}>
            <Typography fontWeight={800} fontSize="1.1rem">
              {booking.reg || "TBC"}
            </Typography>
            <Typography>{vehicleLabel(booking)}</Typography>
          </Box>
          <Box mt={2}>
            <Typography>
              {formatTapDate(booking.arrivalDateTime)} {formatTime(booking.arrivalDateTime)}
            </Typography>
            <Typography>{formatTapDate(booking.returnDateTime)}</Typography>
            <Typography>{booking.rtnFlight || booking.outFlight || "TBC"}</Typography>
            <Typography>{booking.colour || "—"}</Typography>
          </Box>
        </Box>
        <Box textAlign="center">
          <Box component="img" src={qr} alt="QR" width={150} height={150} />
          <Typography fontWeight={800} fontSize="2.6rem" lineHeight={1} mt={1}>
            {formatHeroDate(booking.returnDateTime)}
          </Typography>
          <Typography fontWeight={800} fontSize="2.3rem" lineHeight={1.1} mb={1}>
            {formatTime(booking.returnDateTime)}
          </Typography>
          <Typography fontWeight={800} fontSize="5.5rem" lineHeight={0.9}>
            {returnTerminal}
          </Typography>
          <Typography fontWeight={800} fontSize="2rem" letterSpacing="2px">
            {typeLabel}
          </Typography>
        </Box>
        <Box textAlign="right">
          <Typography fontWeight={800} fontSize="1.1rem">
            {booking.reg || "TBC"}
          </Typography>
          <Box mt={2} fontWeight={600}>
            <div>{vehicleLabel(booking)}</div>
            <div>{booking.colour || "—"}</div>
            <div>{formatTime(booking.returnDateTime)}</div>
            <div>{formatIsoDate(booking.returnDateTime)}</div>
            <div>{returnTerminal}</div>
            <div>{booking.rtnFlight || booking.outFlight || "TBC"}</div>
            <div>{typeLabel}</div>
            <div>{booking.referenceNumber}</div>
          </Box>
        </Box>
      </Box>
      <Box display="flex" justifyContent="space-between" mt={3} fontWeight={700}>
        <span>{booking.referenceNumber}</span>
        <span>{booking.reg || "TBC"}</span>
        <span>{vehicleLabel(booking)}</span>
        <span>{booking.colour || "—"}</span>
      </Box>
    </Box>
  );
};

const DocketsPreviewDialog = ({ open, bookings, dateKey, onClose }) => {
  const handleDownload = async () => {
    try {
      await printDepartureDockets(bookings, dateKey, docketHelpers);
    } catch (err) {
      alert(err.message);
    }
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth>
      <DialogTitle sx={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
        <Typography fontWeight={800}>Departure dockets · {dateKey}</Typography>
        <Box>
          <Button
            variant="contained"
            color="secondary"
            startIcon={<DownloadOutlinedIcon />}
            onClick={handleDownload}
            sx={{ mr: 1 }}
          >
            Download PDF
          </Button>
          <Button startIcon={<PrintIcon />} onClick={handleDownload} sx={{ mr: 1 }}>
            Print
          </Button>
          <IconButton onClick={onClose}>
            <CloseIcon />
          </IconButton>
        </Box>
      </DialogTitle>
      <DialogContent sx={{ backgroundColor: "#e9e9e9" }}>
        {bookings.map((booking, index) => (
          <DocketCard
            key={booking._id || index}
            booking={booking}
            index={index}
            total={bookings.length}
          />
        ))}
      </DialogContent>
    </Dialog>
  );
};

export default DocketsPreviewDialog;
